export enum AppMesages {
    WARNING_VENDOR_AUTHENTICATION_NOTOKEN = 'Authentication Token is not available. Access denied',
    WARNING_VENDOR_AUTHENTICATION_INVALID_TOKEN= 'Authentication Token is invalid. Access denied',
    WARNING_VENDOR_AUTHENTICATION_TOKEN_EXPIRED= 'Vendor authentication URL is expired. Please contact the requestor or system admin to resent the URL',
}

export enum ResponseObjectMesages {
    TOKEN_EXPIRED = 'TOKEN_EXPIRED',
    INVALID_TOKEN= 'INVALID_TOKEN',
}